import { type ColumnDef } from "@tanstack/react-table";
import React, { type FC } from "react";
import { useNavigate } from "react-router-dom";
import {
  PaginationControl,
  ReactTableComponent,
} from "../../../../components/ui-kit";
import { AppRoutes } from "../../../../constants/routes";
import { CustomerApiType } from "../../../../util/types";

interface CustomersTableProps {
  data: CustomerApiType[];
  pagination: PaginationControl;
}

const CustomersTable: FC<CustomersTableProps> = ({ data, pagination }) => {
  const navigate = useNavigate();
  const onRowClick = (row: CustomerApiType) => {
    navigate(`${AppRoutes.Private.Customers.DETAILS}${row._id}`);
  };

  const columns = React.useMemo<Array<ColumnDef<CustomerApiType, any>>>(
    () => [
      {
        header: "Name",
        meta: { mobileTitle: true },
        accessorKey: "name",
        enableSorting: false,
        cell: (info) => info.getValue(),
      },
      {
        header: "Email",
        accessorKey: "email",
        enableSorting: false,
        cell: (info) => info.getValue(),
      },
      {
        header: "Customer company name",
        accessorKey: "customerCompanyName",
        enableSorting: false,
        cell: (info) => {
          const row = info.row.original as CustomerApiType & {
            company?: { name?: string } | null;
          };
          return row.company?.name ?? row.customerCompanyName ?? "-";
        },
      },
      {
        header: "Orders count",
        accessorKey: "ordersCount",
        enableSorting: false,
        cell: (info) => info.getValue() ?? 0,
      },
      {
        header: "Wholesale",
        accessorKey: "isWholesale",
        enableSorting: false,
        cell: (info) => (info.getValue() ? "Yes" : "No"),
      },
      {
        header: "Retail",
        accessorKey: "isRetail",
        enableSorting: false,
        cell: (info) => (info.getValue() ? "Yes" : "No"),
      },
    ],
    []
  );

  return (
    <ReactTableComponent
      columns={columns}
      data={data}
      onRowClick={onRowClick}
      withPagination={pagination}
    />
  );
};

export default CustomersTable;
